import {Suspense, useDeferredValue} from 'react';
import {EvListParams} from '../hooks/list/ev-list.models';
import {ErrorBoundary} from '../errorhandling/ErrorBoundary';
import {EvLoadingSpinnerElement} from '../components/ev-loading-spinner-element';
import {MultilayerPlanListQueryForm} from './multilayer-plan.models';
import {MultilayerPlanList} from './multilayer-plan-list';
import {ArticleSpecification} from '../../envisia/article/models/article-specification.model';
import {MultilayerPlanForm} from './multilayer-plan-form';
import {useEvListFilterHook} from '../hooks/list/ev-list-hook';
import {useMultilayerPlanListQuery} from './use-multilayer-plan-query';

interface Props {
  specification: { [key: string]: ArticleSpecification };
}

const config: EvListParams = {
  stateName: 'a.multilayerplan',
  config: {
    types: {
      shared_id: 'string',
      name: 'string',
      oa_nr: 'string',
      active: 'boolean',
      deleted: 'boolean',
      with_article: 'boolean',
      page: 'int',
      sort: 'string',
      order: 'string',
    },
  },
};

export function MultilayerPlan(props: Props) {
  const filters = useEvListFilterHook<MultilayerPlanListQueryForm>(config);
  const queryParams = useDeferredValue<MultilayerPlanListQueryForm>({...filters.params, shared_id: null});
  const {data, isEnabled, isSuccess} = useMultilayerPlanListQuery({sharedId: filters.params.shared_id});
  const selected = isEnabled && isSuccess ? data : null;

  return <MultilayerPlanForm key={selected?.shared_id ?? null}
                             specification={props.specification}
                             model={selected}
                             selection={(sharedId) => filters.formChanged({shared_id: sharedId})}>
    <h3>Gespeicherte Aufbaupläne</h3>
    <ErrorBoundary>
      <Suspense fallback={<EvLoadingSpinnerElement/>}>
        <MultilayerPlanList filters={filters}
                            queryParams={queryParams}
                            selected={selected}/>
      </Suspense>
    </ErrorBoundary>
  </MultilayerPlanForm>;
}
